var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointUnactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0.172852C3.01821 0.172852 0 3.14635 0 6.82285C0 11.8104 6.75 19.1729 6.75 19.1729C6.75 19.1729 13.5 11.8104 13.5 6.82285C13.5 3.14635 10.4818 0.172852 6.75 0.172852ZM6.75 9.19785C5.41929 9.19785 4.33929 8.13385 4.33929 6.82285C4.33929 5.51185 5.41929 4.44785 6.75 4.44785C8.08071 4.44785 9.16071 5.51185 9.16071 6.82285C9.16071 8.13385 8.08071 9.19785 6.75 9.19785Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointUnactive);
export default __webpack_public_path__ + "static/media/point-unactive.923db72d789d7281dce9a6a0387bcff0.svg";
export { ForwardRef as ReactComponent };